<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>

      <div class="bg1 home" routerLink="/nest/home" style="cursor: pointer">


        <div style="top:30px; right:25px; position:absolute;     z-index: 2000;">

          <ul class="mobile-sub wsmenu-list">



          <li style="cursor: pointer" class="userhomeimg"><a  class="navtext" *ngIf="userStatus ==1; else login"><span>
             <img src="https://passport.petcart.in/images/userimgs/{{userimg}}" style="height:40px" >
             <span class="hidden-sm-down" style="color:#fff">  Hi {{username}}!</span></span></a>
           <div class="megamenu clearfix" style="width:300px; padding: 0px !important; right: 0px;" *ngIf="userStatus ==1 && userrole != 1">
             <div class="pPanel">
               <div class="inner cart-container" style="padding:20px 15px 25px 15px !important">
                 <div class="widget_shopping_cart_content"  >
                   <ul class="cart_list product_list_widget" style="cursor:pointer">
                     <li routerLink="/manageprofile/order">Manage Orders</li>
                     <li routerLink="/manageprofile/manageyourpet">Manage Pets</li>
                     <li routerLink="/manageprofile/appointment">Manage Appointments</li>
                   </ul>
                   <p class="total" *ngIf="lastorder.length>0"  (click)="goForReorder(lastorder[0].orderno)">
                    <strong> Last Transaction:</strong> {{lastorder[0].orderno}} - Reorder
                    </p>

                     <p class="buttons" >
                       <a  routerLink="/manageprofile" class="button wc-forward" style="background-color:#dbd3be; color:#9b7544">My Profile </a>
                       <a (click)="logout()"
                        class="button checkout wc-forward" style="    border: 2px solid #dbd3be; color:#9b7544">Logout</a>
                     </p>


                     <ul class="wstliststy06 clearfix" *ngIf="userStatus == 1 && userrole == 1">
                         <li class="wstheading clearfix" style="cursor:pointer" routerLink="/doctor/home">
                             <mat-icon>power_settings_new</mat-icon>Go to Profile:</li>
                       </ul>
                 </div>

               </div>
             </div>
           </div>


         </li>









        </ul>



      </div>




      <!--menutest-->
      <div class="homesmlmenu hidden-md-down" style="position:absolute; z-index: 1000;">
      <div class="wsmenucontainer clearfix">
          <div id="overlapblackbg"></div>


          <div class="headerfull">
            <!--  <li class="wssearchbar clearfix" style="float:center">
                  <form class="topmenusearch">
                      <input style="margin-right:108px; width: 475px" id="typeahead-template" type="text" name="something" placeholder="Search great products for your wonderful furries"
                      [(ngModel)]="searchterm" [ngbTypeahead]="search" [resultTemplate]="rt"
                      [inputFormatter]="formatter" />
                    <button style="margin-right:55px"  (click)=' goToSearch()' class="btnstyle"><i class="searchicon fa fa-search" aria-hidden="true" style="color: #fff;"></i></button>
                  </form>
                </li> -->

            <div class="dropdown" style="  position: absolute; margin-right:100px;">

              <button class="dropbtn">
              <a style="text-decoration:none;" routerLink="/store/home" class="navtext">
                <span class="hovcolor">   <img src="assets/images/storep.png" class="imgp" ><!--  <i class="fas fa-cart-plus"></i> -->
                <br>  <span style="font-size: 20px; margin-right: 10px; color:#fff;" >Store</span></span>
              </a>
            </button>


       <div class="dropdown-content">

      <div class="wsmain" style="    width: 400px; float:right;">

                  <nav class="wsmenu clearfix" style="background-color:transparent !important; box-shadow:none; border:none;">
                   <ul class="mobile-sub wsmenu-list">

                     <li><a class="navtext"><span></span> <span style="color:#fff">Shop By Pet</span></a>
                       <div class="wsshoptabing wtsdepartmentmenu clearfix" style = "position: absolute;
                      left: 0 !important; width:1050px; height: 460px; z-index:5000;">
                         <div class="wsshopwp clearfix">
                           <ul class="wstabitem clearfix">
                             <li class="wsshoplink-active"><a routerLink="/store/products/1/dog-products.html">Dog</a>
                               <div class="wstitemright clearfix wstitemrightactive">
                                 <div class="container-fluid">
                                   <div class="row">
                                     <div class="col-lg-8 col-md-12 clearfix">
                                       <div class="wstheading clearfix"><a routerLink="/store/products/5/dog-food.html">Dog Food</a></div>
                                       <ul class="wstliststy01 clearfix">
                                         <li><a routerLink="/store/products/15/dog-dry-food.html">Dry Food</a></li>
                                         <li><a routerLink="/store/products/16/dog-wet-food.html">Wet Food</a></li>
                                         <li><a routerLink="/store/products/17/dog-prescription-food.html">Prescription Food</a></li>

                                       </ul>

                                       <div class="wstheading clearfix"><a routerLink="/store/products/6/dog-treats.html">Dog Treats</a></div>
                                       <ul class="wstliststy01 clearfix">
                                         <li><a routerLink="/store/products/18/biscuits.html">Biscuits and Crunchy Treats</a></li>
                                          <li><a routerLink="/store/products/19/dental-treats.html">Dental Treats</a></li>
                                           <li><a routerLink="/store/products/20/soft-treats.html">Soft and Chewy Treats</a></li>
                                            <li><a routerLink="/store/products/21/jerky-treats.html">Jerky Treats</a></li>
                                              <li><a routerLink="/store/products/22/natural-treats.html">Natural Chews</a></li>

                                       </ul>

                                       <div class="wstheading clearfix"><a routerLink="/store/products/7/dog-supplies.html">Supplies</a></div>
                                       <ul class="wstliststy01 clearfix">
                                         <li><a routerLink="/store/products/23/dog-toys.html">Toys</a></li>
                                           <li><a routerLink="/store/products/25/dog-grooming.html">Grooming</a></li>
                                             <li><a routerLink="/store/products/26/dog-cleaning.html">Cleaning</a></li>
                                         <li><a routerLink="/store/products/30/bowls.html">Bowls and Feaders</a></li>
                                         <li><a routerLink="/store/products/24/dog-healthcare.html">Health Care</a></li>
                                          <li><a routerLink="/store/products/29/fashion.html">Costumes and Fashion</a></li>
                                           <li><a routerLink="/store/products/28/accessories.html">Accessories</a></li>
                                            <li><a routerLink="/store/products/27/beds.html">Beds and Mats</a></li>





                                       </ul>



                                     </div>

                                      <div class="col-lg-4 col-md-12 clearfix"><a class="wstmegamenucolr"><img src="assets/images/dogmenu.jpg" alt="" ></a></div>

                                   </div>
                                 </div>
                               </div>
                             </li>




                             <li><a routerLink="/store/products/2/catproducts.html">Cat</a>
                               <div class="wstitemright clearfix">
                                 <div class="container-fluid">
                                   <div class="row">
                                     <div class="col-lg-8 col-md-12 clearfix">
                                       <div class="wstheading clearfix"><a routerLink="/store/products/8/cat-food.html">Cat Food</a></div>
                                       <ul class="wstliststy01 clearfix">
                                         <li><a routerLink="/store/products/31/cat-dry-food.html">Dry Food</a></li>
                                         <li><a routerLink="/store/products/32/cat-wet-food.html">Wet Food</a></li>
                                         <li><a routerLink="/store/products/33/cat-prescription-food.html">Prescription Food</a></li>


                                       </ul>



                                       <div class="wstheading clearfix"><a routerLink="/store/products/9/cat-treats.html">Cat Treats</a></div>
                                       <ul class="wstliststy01 clearfix">
                                         <li><a routerLink="/store/products/34/biscuits.html">Biscuits and Crunchy Treats</a></li>
                                          <li><a routerLink="/store/products/35/dental-treats.html">Dental Treats</a></li>
                                           <li><a routerLink="/store/products/36/soft-treats.html">Soft and Chewy Treats</a></li>
                                            <li><a routerLink="/store/products/37/jerky-treats.html">Jerky Treats</a></li>

                                       </ul>

                                       <div class="wstheading clearfix"><a routerLink="/store/products/10/cat-litter.html">Cat Litter and Accessories</a></div>
                                       <ul class="wstliststy01 clearfix">
                                         <li><a routerLink="/store/products/38/litter.html">Cat Litter</a></li>
                                          <li><a routerLink="/store/products/39/litter-tray.html">Litter Trays</a></li>
                                           <li><a routerLink="/store/products/40/waste-disposal.html">Waste Disposal</a></li>
                                            <li><a routerLink="/store/products/41/cleaners.html">Cleaners and Deodorizers</a></li>

                                       </ul>

                                       <div class="wstheading clearfix"><a routerLink="/store/products/11/cat-supplies.html">Supplies</a></div>
                                       <ul class="wstliststy01 clearfix">
                                         <li><a routerLink="/store/products/47/cat-toys.html">Toys</a></li>
                                           <li><a routerLink="/store/products/45/cat-grooming.html">Grooming</a></li>
                                             <li><a routerLink="/store/products/43/cat-cleaning.html">Cleaning</a></li>
                                         <li><a routerLink="/store/products/46/cat-healthcare.html">Health Care</a></li>
                                          <li><a routerLink="/store/products/44/fashion.html">Costumes and Fashion</a></li>
                                           <li><a routerLink="/store/products/42/accessories.html">Accessories</a></li>


                                       </ul>







                                     </div>
                                     <div class="col-lg-4 col-md-12 clearfix"><a class="wstmegamenucolr"><img src="assets/images/catmenu.jpg" alt="" ></a></div>
                                   </div>
                                 </div>
                               </div>
                             </li>



                           </ul>
                         </div>
                       </div>
                     </li>
                       <li><a class="navtext"><span></span> <span style="color:#fff">Shop By Brand</span></a>
                          <div class="megamenu clearfix" style ="position: absolute;
                          left: 0 !important; width:1050px; height: 460px; z-index:5000;  background-color: #f7f4ea;
                            color: #9b7544;box-shadow: 0 1px 4px rgba(0, 0, 0, .5);font-size: 2em;">
                            <div class="container-fluid">
                              <div class="row">
                                <div class="col-lg-3 col-md-12">
                                  <ul class="wstliststy02 clearfix">

                                      <li class="wstheading clearfix"> A-C </li>
                                          <li><a routerLink="/store/search/brand/10">Arden Grange</a></li>
                                          <li><a routerLink="/store/search/brand/11">Aroma Tree</a></li>
                                          <li><a routerLink="/store/search/brand/13">Bayer</a></li>
                                          <li><a routerLink="/store/search/brand/14">Beaphar</a></li>
                                          <li><a routerLink="/store/search/brand/15">Bellotta</a></li>
                                          <li><a routerLink="/store/search/brand/18">BI</a></li>
                                          <li><a routerLink="/store/search/brand/20">Bio-Groom</a></li>
                                          <li><a routerLink="/store/search/brand/21">Canine Creek</a></li>
                                          <li><a routerLink="/store/search/brand/119">Capt Zack</a></li>
                                          <li><a routerLink="/store/search/brand/23">Cat Exclusive</a></li>
                                          <li><a routerLink="/store/search/brand/25">Cataholic</a></li>
                                          <li><a routerLink="/store/search/brand/24">Cats Best</a></li>
                                          <li><a routerLink="/store/search/brand/26">Chappi</a></li>
                                          <li><a routerLink="/store/search/brand/29">Chip Chops</a></li>
                                          <li><a routerLink="/store/search/brand/31">Choostix</a></li>
                                  </ul>
                                </div>
                                <div class="col-lg-3 col-md-12">
                                  <ul class="wstliststy02 clearfix">
                                    <li class="wstheading clearfix">D-L</li>
                                        <li><a routerLink="/store/search/brand/35">Delite</a></li>
                                        <li><a routerLink="/store/search/brand/36">Dogaholic</a></li>
                                        <li><a routerLink="/store/search/brand/37">Doggy Dolly</a></li>
                                        <li><a routerLink="/store/search/brand/41">Drools</a></li>
                                        <li><a routerLink="/store/search/brand/45">Fidele</a></li>
                                        <li><a routerLink="/store/search/brand/52">Gnawlers</a></li>
                                        <li><a routerLink="/store/search/brand/54">GoodieS</a></li>
                                        <li><a routerLink="/store/search/brand/56">Happy Cat</a></li>
                                        <li><a routerLink="/store/search/brand/59">Hills</a></li>
                                        <li><a routerLink="/store/search/brand/60">Himalaya</a></li>
                                        <li><a routerLink="/store/search/brand/64">JerHigh</a></li>
                                        <li><a routerLink="/store/search/brand/65">Jinny</a></li>
                                        <li><a routerLink="/store/search/brand/67">Kennel Kitchen</a></li>
                                        <li><a routerLink="/store/search/brand/4">Lets Bite</a></li>
                                  </ul>
                                </div>
                                <div class="col-lg-3 col-md-12">
                                  <ul class="wstliststy02 clearfix">
                                    <li class="wstheading clearfix">M-T</li>
                                          <li><a routerLink="/store/search/brand/70">Me-O</a></li>
                                          <li><a routerLink="/store/search/brand/72">mybeau</a></li>
                                          <li><a routerLink="/store/search/brand/80">Others</a></li>
                                          <li><a routerLink="/store/search/brand/81">Pedigree</a></li>
                                          <li><a routerLink="/store/search/brand/86">Petkin</a></li>
                                          <li><a routerLink="/store/search/brand/90">Purepet</a></li>
                                          <li><a routerLink="/store/search/brand/1">Royal Canin</a></li>
                                          <li><a routerLink="/store/search/brand/94">Savic</a></li>
                                          <li><a routerLink="/store/search/brand/96">Sheba</a></li>
                                          <li><a routerLink="/store/search/brand/97">Simple Solution</a></li>
                                          <li><a routerLink="/store/search/brand/98">Smart Heart</a></li>
                                          <li><a routerLink="/store/search/brand/101">Standard</a></li>
                                          <li><a routerLink="/store/search/brand/105">Trixie</a></li>
                                          <li><a routerLink="/store/search/brand/106">Twistix</a></li>
                                  </ul>
                                </div>
                                <div class="col-lg-3 col-md-12">
                                  <ul class="wstliststy02 clearfix">
                                    <li class="wstheading clearfix">U-Z</li>
                                            <li><a routerLink="/store/search/brand/109">Versele Laga</a></li>
                                            <li><a routerLink="/store/search/brand/111">Virbac</a></li>
                                            <li><a routerLink="/store/search/brand/112">Vitapol</a></li>
                                            <li><a routerLink="/store/search/brand/113">WAHL</a></li>
                                            <li><a routerLink="/store/search/brand/114">Whiskas</a></li>

                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>










                   </ul>
                 </nav>

                </div>
            </div>
          </div>


         <div class="dropdown" style="  position: absolute; margin: 0 0 0 110px;">
           <button class="dropbtn">
               <a  style="text-decoration:none;"  routerLink="/pulse/home" class="navtext">
              <span class="hovcolor"><img src="assets/images/pulsep.png" class="imgp" ><!--<i class="fas fa-user-md"></i> -->
               <br>    <span style="font-size: 20px; margin-right: 10px; color:#fff;" >Pulse</span></span>
               </a>
             </button>


            <div class="dropdown-content">

                  <ul class="pulsemenu2">
                    <li><a routerLink="/pulse/doctor">Appointment with a Vet</a></li>
                    <li><a routerLink="/pulse/onlinedoctors">Chat with a Vet</a></li>
                    <li><a routerLink="/pulse/doctor">Set Reminders</a></li>
                    <li><a routerLink="/manageprofile/manageyourpet">Scan Records</a> </li>
                    <li><a routerLink="/pulse/doctor">Know Yourself</a></li>
                    <li><a routerLink="/vets">For Vets</a></li>
                  </ul>

            </div>
          </div>


          <div class="dropdown" style="  position: absolute; margin: 0 0 0 219px;">
            <button class="dropbtn">
              <a  style="text-decoration:none;"  routerLink="/nest/home" class="navtext">
              <span class="hovcolor"><img src="assets/images/nestp.png" class="imgp" ><!--<i class="fas fa-home"></i> -->
              <br>    <span style="font-size: 20px; margin-right: 10px; color:#fff;">Nest</span></span>
              </a>
            </button>



          </div>









              </div>

                </div>
      </div>

















      <!--menutest-->















<!--      <div class="div-block home">
    <div class="w-row">
      <div class="column-3 w-col w-col-1 w-col-small-1 w-col-tiny-1" style="    width: 15.333333%; padding-top: 5px !important;">
        <img src="\assets\images\home1.gif" width="100" class="dog">
      </div>
      <div class="column w-col w-col-9 w-col-small-9 w-col-tiny-9">
        <p class="paragraph _1">PETCART is the first integrated pet solutions provider with the intent of creating Healthier Pets and Happier Pet Parents.</p>
      </div>

      <div _ngcontent-c4="" class="column-9 w-col w-col-3 w-col-small-3 w-col-tiny-6" style ="
  float: right;
  margin-top: 10px;
">
<img _ngcontent-c4="" src="\assets\images\iosapp.png" style="height: 40px;width: 140px;">
  <img _ngcontent-c4="" src="\assets\images\googleapp.png" style="height: 65px;width: 163px;margin-left: -11px;">
        </div>
      </div>
  </div>-->






  </div>

<div class="mobwebmenu hidden-md-up">
  <div class="mobwebmenuitem">
  <a style="text-decoration:none;" routerLink="/store/home" class="navtext">
    <span class="hovcolor">   <img style="margin-bottom: -10px;" src="assets/images/storep.png" class="imgp" ><!--  <i class="fas fa-cart-plus"></i> -->
    <br>  <span style="font-size: 20px; color:#76542a;" >Store</span></span>
  </a>
</div>
<div class="mobwebmenuitem">
  <a  style="text-decoration:none;"  routerLink="/pulse/home" class="navtext">
 <span class="hovcolor"><img style="margin-bottom: -10px;" src="assets/images/pulsep.png" class="imgp" ><!--<i class="fas fa-user-md"></i> -->
  <br>    <span style="font-size: 20px; color:#76542a;" >Pulse</span></span>
  </a>
</div>
<div class="mobwebmenuitem">
  <a  style="text-decoration:none;"  routerLink="/nest/home" class="navtext">
  <span class="hovcolor"><img style="margin-bottom: -10px;" src="assets/images/nestp.png" class="imgp" ><!--<i class="fas fa-home"></i> -->
  <br>    <span style="font-size: 20px; color:#76542a;" >Nest</span></span>
  </a>
</div>

</div>



  <div class="bg3">
    <div class="w-container"  routerLink="/store/home">
      <div id="pet-pulse" class="div-block-9"><img src="\assets\images\shutterstock_33069628.jpeg"  style="    max-width: 500px !important;" class="image-2"></div>
      <div data-w-id="e0516abe-4c6c-4990-493e-976b56128387" class="div-block-8">
        <h3 class="pet">Store</h3>
        <p class="paragraph-2 _1" style="text-align:justify;">Just like cuddly little babies, pets need special care and attention. After all, their happiness does make you happy too! Store is our online shopping platform for pet (dog, cat, bird, fish) essentials including food, treats and other essentials. PETCART Store aims to deliver the right products to your doorstep in right time to keep your furry bundles of joy happy and satisfied.</p><a routerLink="/store/home" class="link block">Shop Now &gt;&gt;</a></div>
    </div>
    <div class="w-container" style="margin-top: 90px !important" routerLink="/pulse/home" >
      <div id="pet-store" class="div-block-10"><img src="\assets\images\Photo1.png" style="    max-width: 500px !important;" class="image-3"></div>
      <div data-w-id="513f513b-f10f-e4ff-5f11-e2cadfc7f62a" class="div-block-11">
        <h3 class="pet pet_1">Pulse</h3>
        <p class="paragraph-2 _1" style="text-align:justify;">Does your heart skip a beat when your pet shows signs of illness? Do you yourself get worried when your pet is unwell? You don’t have to worry anymore. Pulse is PETCART’s pet project and the first-of-its-kind tech platform for pet care. Pulse is your one-stop destination for booking appointments with vets, follow-ups, storing records, vaccination reminders, expert advice and lot more. We also facilitate real time interaction (text / video) with available Veterinarians to keep our furry friends happy and healthy at all times.</p><a routerLink="/pulse/home"  class="link block">Visit Now &gt;&gt;</a></div>
    </div>
    <div class="container-3 w-container" routerLink="/nest/home">
      <div id="pet-nest" class="div-block-9 _1">
        <img src="\assets\images\home-page---nest-section.jpeg" class="image-2" ></div>
      <div data-w-id="3c98ac30-d29c-03a4-ff10-3ccf7cffdad9" class="div-block-8 next">
        <h3 class="pet">Nest</h3>
        <p class="paragraph-2 _1" style="text-align:justify;">Give your pets a fun holiday at a luxury pet resort with world class facilities! Nest is the first-of-its-kind pet resort in India that caters to all the needs of your pets. So get your pets ready, pack their bags, and send them on the best holiday of their life. They can run around, make friends, get pampered at our grooming studio and have an absolute time of their life. Promise! Pet parents are also allowed to have their share of fun with their fur babies through our offerings.</p><a href="#" class="link block">Visit Now &gt;&gt;</a></div>
    </div>
  </div>
  <div class="bg4">
    <div class="row w-row" style="background-color: #dbd3be; margin: 0px !important;">
      <div routerLink="/petadoption/home" class="column-4 w-clearfix w-col w-col-6 w-col-small-small-stack w-col-stack"><img src="\assets\images\adoption-center.png" data-w-id="14491368-58e2-d5fd-e85b-871f49d1a8a7" class="image-4">
        <div class="div-block-13" style="">
          <h1 class="heading-text">ADOPTION CENTER</h1>
          <p class="text">We at PETCART will never sell pets. Our heart goes out to homeless cats and dogs. Every dog and cat deserves loving home and caring parents. If you want to give one of them a chance at living happily ever after, get in touch with PETCART’s adoption center. Many individuals who want to give their puppy / adult pets for adoption don’t find proper channel. With PETCART adoption center we are trying to create a platform to find a purr-fect home for pets.</p><a routerLink="/petadoption/home" class="link block">Visit PETCART Adoption Center   &gt;&gt;</a></div>
        <div class="div-block-14 w-hidden-medium w-hidden-small w-hidden-tiny"></div>
      </div>
      <div class="hidden-md-up sepline">
      </div>
      <div routerLink="/blogs/category" class="column-5 w-clearfix w-col w-col-6 w-col-small-small-stack w-col-stack"><img routerLink="/blogs/category" src="\assets\images\knowledge-center-copy.png" height="245" srcset="\assets\images\knowledge-center-copy-p-500.png 500w, \assets\images\knowledge-center-copy.png 601w" sizes="(max-width: 479px) 98vw, (max-width: 991px) 99vw, 50vw" class="image-5">
        <div class="div-block-13 _1" style="width:53%">
          <h1 class="heading-text" routerLink="/blogs/category">KNOWLEDGE CENTER</h1>
          <p class="text" style="min-height: 252px;">Are you a first-time pet parent? Are you looking for some information about breed? We have put across various verified articles from Pet experts on different aspects of pets. PETCART is your best friend for all pet related information. We cover categories like: Health And Wellness, Behaviour, Care and General Management, Breed, Nutrition And diet</p><a routerLink="/blogs/category" class="link block">Visit PETCART Knowledge Center &gt;&gt;</a></div>
      </div>
    </div>

    <div class="bg2">

      <div class="div-block-7">
        <div class="container-5 w-container">
          <h1 class="about">About PETCART</h1>
          <p class="paragraph _2">Pet parents are the happiest people on earth. As pet parents ourselves, we can vouch for that. From our endless interactions with pet parents, we created PETCART as an innovative, one-of-its-kind platform that caters to all your pet’s needs throughout their life cycle. PETCART is India’s first fully integrated pet solutions company that’s here to foster healthy and happy pet world.
          </p>



          </div>
      </div>
    </div>

    <div class="footer">
      <app-footer></app-footer>
    </div>
  </div>

  <ng-template #login>

      <div class="wstheading clearfix" id="loginbtn2" style="cursor:pointer; border:none;     margin: 15px 60px 0px 0px; color:#fff;" routerLink="/signin">
          <mat-icon style="    vertical-align: middle;">power_settings_new</mat-icon>Log In</div>

      </ng-template>

      <ng-template #rt let-r="result" let-t="term" style="height:500px">
          <div (click)="goToDetail(r.id,r.url,r.type)">
            <span style="font-size:12px; font-weight:bold;">{{ r.title}}</span>
          </div>
          </ng-template>
